import { GoDotFill, GoPlus } from "react-icons/go";
import { Button, InputField } from "../../../components/forms";
import { nodept } from "../../../constant/import";
import useLeaveHook from "../../../hooks/useLeaveHook";
import PositionItem from "./PositionItem";
import LeaveTypeITem from "./Leave/LeaveTypeITem";
import { Fragment, useEffect, useState } from "react";
import { FaCalendar, FaDotCircle } from "react-icons/fa";
import { BsPersonCheck, BsPersonFillDash } from "react-icons/bs";
import { Menu, Transition } from "@headlessui/react";
import { CiEdit } from "react-icons/ci";
import { FiFileMinus } from "react-icons/fi";
import { IoMdEye, IoMdMore } from "react-icons/io";
import {
  MdClose,
  MdDelete,
  MdOutlineCancel,
  MdOutlineInfo,
} from "react-icons/md";
import { LuUser } from "react-icons/lu";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import { useForm } from "react-hook-form";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
import useEmployeeHook from "../../../hooks/useEmployeeHook";
import { onUpdateGoal } from "../../../services/goals";
import { toast } from "react-toastify";

export default ({ setshowaddleavemodal, isAdminview, goals, refresh }: any) => {
  const EmptyList = () => (
    <div className=" mx-6 p-5 scale-[.75]   text-textbg flex flex-col justify-center rounded-xl items-center border border-gray-300 ">
      <img src={nodept} />
      <p className="font-bold">No Goals</p>
      <small>No goals added yet</small>

      <Button
        width={200}
        disabled={false}
        text={
          <>
            <GoPlus size={15} className=" mx-1 inline" />
            Add goal
          </>
        }
        onBtnClick={() => {
          setshowaddleavemodal(true);
        }}
      />
    </div>
  );
  const { authuser } = useStateGetter();
  return (
    <div className="w-full">
      <div>
        {goals.length > 0 ? (
          <div className="grid grid-cols-2 gap-2 my-2 ">
            {authuser.isEmployee
              ? goals.map((item: any) => (
                  <GoalItem2 item={item} refresh={refresh} />
                ))
              : goals.map((item: any) => (
                  <GoalItem item={item} refresh={refresh} />
                ))}
          </div>
        ) : (
          <EmptyList />
        )}
      </div>
    </div>
  );
};

const GoalItem = ({ item, refresh }) => {
  const { setShowModal, showModal } = useStateSetter();
  const {} = useStateGetter();
  const RejectGoalModal = () => {
    const { control } = useForm();

    return (
      <div className="flex flex-col justify-center w-full items-center">
        <MdOutlineInfo size={30} className="text-primary my-2" />
        <p className="font-semibold"> Reject Goal </p>
        <small className="font-light text-gray-500   text-center">
          You are about to reject employee goal
        </small>
        <div className="w-full">
          <InputField
            name="reason"
            title="Reason"
            placeholder={"Reason for rejection"}
            isTextArea
            control={control}
          />
        </div>

        <div className=" gap-6 w-full flex ">
          <Button
            outlined
            disabled={false}
            text="Cancel"
            onBtnClick={() => {
              setShowModal(false);
            }}
          />
          <Button
            disabled={false}
            text="Reject"
            onBtnClick={async () => {
              //  await RejectLeave(item.id, getValues("reason"));
              refresh();
            }}
          />
        </div>
      </div>
    );
  };

  const ViewGoalModal = () => {
    const { selectedOrgEmployees } = useEmployeeHook();
    var [emp, setemp] = useState<any>({});
    useEffect(() => {
      // if (item.employeeID) {
      //   setemp(
      //     selectedOrgEmployees.filter((kl: any) => kl.id == item.employeeID)[0]
      //   );
      // }
    }, []);

    return (
      <div className="flex flex-col justify-start w-full items-start">
        <p className="font-semibold w-full flex justify-between text-sm">
          {item.employeeID && "Employee"} {item.deptID && "Department"}
          {item.positionID && "Position"} Goal
          <MdOutlineCancel
            onClick={() => setShowModal(false)}
            size={20}
            className="text-gray-400"
          />
        </p>
        <p className="text-sm w-full my-2">
          <GoDotFill
            size={15}
            className={`${
              item.status == "pending" || item.status == "rejected"
                ? "text-[#F79009]"
                : ""
            }  ${item.status == "approved" ? "text-green-400" : ""} inline `}
          />
          {item.status}
        </p>

        <div className="flex mt-2 flex-col w-full">
          {item.target == "employee" && (
            <div className="flex">
              <LuUser
                className="  p-2 rounded-full bg-faintBlue  text-textbg"
                size={50}
              />
              <div className="m-2">
                <p className="font-semibold text-sm">
                  {emp?.firstName} {emp?.lastName}
                </p>
                <p className="font-light text-xs">{emp?.workEmail} </p>
                <p className="font-light   ">
                  <span className="bg-faint text-xs mx-1 rounded"></span>

                  <span className="bg-faint text-xs mx-1 rounded"></span>
                </p>
              </div>
            </div>
          )}
          <div className="p-3 bg-gray-100 px-4 w-full rounded">
            <p className="w-full flex justify-between text-xs">
              <span className="font-medium ">Goal title</span>
              <span className="font-medium">{item.title}</span>
            </p>
            <p className="w-full flex justify-between text-xs">
              <span className="font-medium ">Progress</span>
              <span className="font-medium">{item.progress}</span>
            </p>
            <p className="w-full flex justify-between text-xs">
              <span className="font-medium ">Date</span>
              <span className="font-medium">
                {new Date(item.date).toDateString()}
              </span>
            </p>

            <p className="w-full flex  flex-col text-xs">
              <span className="font-medium ">Note</span>
              <span className="font-light rounded mt-2 bg-white p-2">
                Note:{item.desc}
              </span>
            </p>
          </div>
          {true ? (
            <div className=" gap-6 w-full flex ">
              <Button
                outlined
                disabled={false}
                text="Reject"
                onBtnClick={async () => {
                  showModal("", "", <></>, <RejectGoalModal />);
                }}
              />
              <Button
                disabled={false}
                text="Approve"
                onBtnClick={async () => {
                  //  await ApproveLeave(item.id);
                  refresh();
                }}
              />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="border border-1 flex justify-between text-textbg border-gray-200 py-3 px-2 rounded-[8px] bg-white gap-2">
      <div>
        {" "}
        <p className="font-semibold text-gray-700 ">{item.title}</p>
        <p className=" text-sm">{item.desc}</p>
        <div className="flex">
          <p className="text-xs font-semiboldx">
            <FaCalendar className="inline mr-1" />
            {new Date(item.date).toDateString()}
          </p>{" "}
          <p className="text-xs font-semiboldx">
            <p className="text-xs  capitalize font-light">
              <BsPersonCheck
                size={15}
                className="inline m-1 bg-bluegray700 text-white p-.5 rounded"
              />
              {item.target} | {item.progress}
            </p>
          </p>
          <p className="text-xs font-semiboldx">
            <GoDotFill
              size={15}
              className={`${
                item.status.toLowerCase().includes("active") ||
                item.status.includes("Cancel")
                  ? "text-[#F79009]"
                  : ""
              }  ${
                item.status.includes("In-Progress") ? "text-blue-400" : ""
              }  ${
                item.status.includes("done") ? "text-green-400" : ""
              } inline `}
            />
            {item.status.toLowerCase().includes("active")
              ? "pending"
              : item.status}
          </p>
        </div>
      </div>
      <Menu as="div" className={`relative my-2 `}>
        <Menu.Button className="   w-full       ">
          <IoMdMore />
        </Menu.Button>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items
            onClick={() => {}}
            className="origin-top-left z-10 absolute left-0 mt-2 rounded-sm shadow-md p-1 bg-white w-full  max-h-[200px] min-w-[180px]   overflow-x-hidden overflow-y-scroll ring-1 ring-black ring-opacity-5 focus:outline-none"
          >
            <Menu.Item>
              <p
                onClick={() => {
                  showModal("", "", <></>, <ViewGoalModal />);
                }}
                className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
              >
                <CiEdit className="inline" /> View
              </p>
            </Menu.Item>
            <Menu.Item>
              <p
                onClick={() => {}}
                className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
              >
                <MdDelete className="inline" /> Delete
              </p>
            </Menu.Item>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
};
const GoalItem2 = ({ item, refresh }) => {
  const { setShowModal, showModal } = useStateSetter();
  const { config } = useStateGetter();
  const { setLoading } = useStateSetter();
  const UpdateGoalProgress = () => {
    const { control } = useForm();
    const [progress, setprogress] = useState(item.progress);
    const progressITems = [
      "0%",
      "10%",
      "20%",
      "30%",
      "40%",
      "50%",
      "60%",
      "70%",
      "80%",
      "90%",
      "100%",
    ];
    const Progress = ({ item }) => {
      return (
        <div
          onClick={() => {
            setprogress(item);
          }}
          className={`px-1 py-2 text-xs cursor-pointer flex justify-center rounded-[8px]   items-center  ${
            progress == item
              ? "bg-primary text-white"
              : " border-2 border-solid border-gray-500"
          }`}
        >
          {item}
        </div>
      );
    };
    return (
      <div className="flex flex-col   w-full  ">
        <MdClose
          onClick={() => setShowModal(false)}
          size={30}
          className="text-gray-300 place-self-end my-2"
        />
        <p className="font-semibold"> Update Goal Progress </p>
        <small className="font-light text-gray-500">Progress</small>
        <div className="flex p-2 overflow-x-scroll gap-1">
          {progressITems.map((it: string) => (
            <Progress item={it} />
          ))}
        </div>

        <div className=" gap-6 w-full flex ">
          <Button
            disabled={false}
            text="Save"
            onBtnClick={async () => {
              try {
                setLoading(true);
                await onUpdateGoal(item.id, { progress: progress }, config);
                toast.success("Progress updated!");
              } catch (e) {
                console.log(e);
              } finally {
                setLoading(false);
                setShowModal(false);
                refresh();
              }
            }}
          />
        </div>
      </div>
    );
  };

  const AcknowledgrGoalModal = () => {
    const { control } = useForm();

    return (
      <div className="flex flex-col   w-full ">
        <MdClose
          onClick={() => {
            setShowModal(false);
          }}
          size={20}
          className="text-gray-400  place-self-end my-2"
        />
        <p className="font-semibold">Acknowledge </p>

        <div className="w-full">
          <InputField
            name="note"
            title="Note"
            placeholder={"Enter a note"}
            isTextArea
            control={control}
          />
        </div>

        <div className=" gap-6 w-full flex ">
          <Button
            disabled={false}
            text="Send"
            onBtnClick={async () => {
              setShowModal(false);
            }}
          />
        </div>
      </div>
    );
  };

  const ViewGoalModal = () => {
    const { selectedOrgEmployees } = useEmployeeHook();
    var [emp, setemp] = useState<any>({});
    useEffect(() => {
      // if (item.employeeID) {
      //   setemp(
      //     selectedOrgEmployees.filter((kl: any) => kl.id == item.employeeID)[0]
      //   );
      // }
    }, []);

    return (
      <div className="flex flex-col justify-start w-full items-start">
        <p className="font-semibold w-full flex justify-between text-sm">
          {item.employeeID && "Employee"} {item.deptID && "Department"}
          {item.positionID && "Position"} Goal
          <MdOutlineCancel
            onClick={() => setShowModal(false)}
            size={20}
            className="text-gray-400"
          />
        </p>
        <p className="text-sm w-full my-2">
          <GoDotFill
            size={15}
            className={`${
              item.status == "pending" || item.status == "rejected"
                ? "text-[#F79009]"
                : ""
            }  ${item.status == "approved" ? "text-green-400" : ""} inline `}
          />
          {item.status}
        </p>

        <div className="flex mt-2 flex-col w-full">
          {item.target == "employee" && (
            <div className="flex">
              <LuUser
                className="  p-2 rounded-full bg-faintBlue  text-textbg"
                size={50}
              />
              <div className="m-2">
                <p className="font-semibold text-sm">
                  {emp?.firstName} {emp?.lastName}
                </p>
                <p className="font-light text-xs">{emp?.workEmail} </p>
                <p className="font-light   ">
                  <span className="bg-faint text-xs mx-1 rounded"></span>

                  <span className="bg-faint text-xs mx-1 rounded"></span>
                </p>
              </div>
            </div>
          )}
          <div className="p-3 bg-gray-100 px-4 w-full rounded">
            <p className="w-full flex justify-between text-xs">
              <span className="font-medium ">Goal title</span>
              <span className="font-medium">{item.title}</span>
            </p>
            <p className="w-full flex justify-between text-xs">
              <span className="font-medium ">Progress</span>
              <span className="font-medium">{item.progress}</span>
            </p>
            <p className="w-full flex justify-between text-xs">
              <span className="font-medium ">Date</span>
              <span className="font-medium">
                {new Date(item.date).toDateString()}
              </span>
            </p>

            <p className="w-full flex  flex-col text-xs">
              <span className="font-medium ">Note</span>
              <span className="font-light rounded mt-2 bg-white p-2">
                Note:{item.desc}
              </span>
            </p>
          </div>

          <div className=" gap-6 w-full flex ">
            {item.progress == "100%" ? (
              <Button
                outlined
                disabled={false}
                text="Acknowledge"
                onBtnClick={() => {
                  showModal("", "", "", <AcknowledgrGoalModal />);
                }}
              />
            ) : (
              <Button
                disabled={false}
                text="Update Progress"
                onBtnClick={() => {
                  showModal("", "", "", <UpdateGoalProgress />);
                }}
              />
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="border border-1 flex justify-between text-textbg border-gray-200 py-3 px-2 rounded-[8px] bg-white gap-2">
      <div>
        {" "}
        <p className="font-semibold text-gray-700 ">{item.title}</p>
        <p className=" text-sm">{item.desc}</p>
        <div className="flex">
          <p className="text-xs font-semiboldx">
            <FaCalendar className="inline mr-1" />
            {new Date(item.date).toDateString()}
          </p>{" "}
          <p className="text-xs font-semiboldx">
            <p className="text-xs  capitalize font-light">
              <BsPersonCheck
                size={15}
                className="inline m-1 bg-bluegray700 text-white p-.5 rounded"
              />
              {item.target} | {item.progress}
            </p>
          </p>
          <p className="text-xs font-semiboldx">
            <GoDotFill
              size={15}
              className={`${
                item.status.toLowerCase().includes("active") ||
                item.status.includes("Cancel")
                  ? "text-[#F79009]"
                  : ""
              }  ${
                item.status.includes("In-Progress") ? "text-blue-400" : ""
              }  ${
                item.status.includes("done") ? "text-green-400" : ""
              } inline `}
            />
            {item.status.toLowerCase().includes("active")
              ? "pending"
              : item.status}
          </p>
        </div>
      </div>
      <Menu as="div" className={`relative my-2 `}>
        <Menu.Button className="   w-full       ">
          <IoMdMore />
        </Menu.Button>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items
            onClick={() => {}}
            className="origin-top-left z-10 absolute left-0 mt-2 rounded-sm shadow-md p-1 bg-white w-full  max-h-[200px] min-w-[180px]   overflow-x-hidden overflow-y-scroll ring-1 ring-black ring-opacity-5 focus:outline-none"
          >
            <Menu.Item>
              <p
                onClick={() => {
                  showModal("", "", <></>, <ViewGoalModal />);
                }}
                className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
              >
                <CiEdit className="inline" /> View
              </p>
            </Menu.Item>
            <Menu.Item>
              <p
                onClick={() => {}}
                className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
              >
                <MdDelete className="inline" /> Delete
              </p>
            </Menu.Item>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
};
const todatestring = (datestring: string) => {
  var date = new Date(datestring);

  return date.toDateString();
};
